import { useAppActions } from 'reducers/slices/loanOfficerSettingsSlice';
import { useSelector } from 'react-redux';

export default () => {
  const { requestProfileReview } = useAppActions();
  const { loading } = useSelector(state => state.loanOfficerSettingsSlice);

  return {
    loading,
    requestProfileReview,
  };
};



// WEBPACK FOOTER //
// ./src/reducers/hooks/useLoanOfficerSettings.js